import {
  BookingDetailsViewContainer,
  type BookingDetailsViewContainerProps,
} from './BookingDetailsViewContainer';

interface BookingDetailsViewProps extends BookingDetailsViewContainerProps {}

export const BookingDetailsView = (props: BookingDetailsViewProps) => {
  return <BookingDetailsViewContainer {...props} />;
};
